import _ from 'lodash';
import mask from '../../directives/inputmask';

export default {
  inject: ['$validator'],
  props: {
    value: null,
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    vMask: null,
    autocomplete: null,
    cssClass: null,
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    },
    validation: {
      default: ''
    },
    validationScope: {
      default: ''
    }
  },
  data: data,
  directives:{
    mask
  }
}

function data(){
  return {
    name$: _.isEmpty(this.name) ? `input_${this._uid}` : this.name
  };
}